import { type AppThunk } from "../../../index";
import { unsubscribeFromProductClient as action } from "../reducer";
import { closeRealtimeChannel } from "../../../helpers/closeRealtimeChannel";
import { claimRealtimeSlot } from "../../../helpers/realtimeSlot";

export const unsubscribeFromProductClient =
  (): AppThunk =>
  async (dispatch, getState, { subscriptions, db }) => {
    // take the slot so a subscribe still waiting on its fetch does not resurrect the channel
    claimRealtimeSlot(subscriptions, "productClient");

    // detach synchronously - awaiting the close first would let a subscribe that
    // already claimed the slot store its channel, only for this thunk to null it out
    const channel = subscriptions.realtimeProductClientChannel;
    subscriptions.realtimeProductClientChannel = null;
    subscriptions.productClientChannelName = null;
    void closeRealtimeChannel(db, channel);
    dispatch(action());
  };
